import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-testid": "step-returnToDesktop",
  class: "container"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = { class: "t-bold t-center container__subheader" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.personalDataHeader`)), 1),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.responseData.uploadActionError) + " ", 1),
      _hoisted_4,
      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.continuingRegistrationProcess`)), 1)
    ])
  ]))
}